import { Checkbox } from 'radix-ui';
import { Typography } from '../Typography';
import { Square, SquareCheck } from '../svgs';
import { PropsWithChildren } from 'react';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

export interface CheckboxItemProps extends Checkbox.CheckboxProps {
  containerClassName?: string;
  labelClassName?: string;
}

export const CheckboxItem = ({
  children,
  containerClassName,
  labelClassName,
  className,
  checked,
  id,
  ...otherProps
}: PropsWithChildren<CheckboxItemProps>) => {
  const Icon = checked ? SquareCheck : Square;
  return (
    <div className={clsx('flex items-center gap-[--padding-xs]', containerClassName)}>
      <Checkbox.Root
        className={clsx(
          'flex size-[24px] appearance-none items-center justify-center rounded outline-none shadow-none',
          className
        )}
        id={id}
        checked={checked}
        {...otherProps}
      >
        <Icon height={24} width={24} className={twMerge('text-[--checkbox-checkbox-default]')} />
      </Checkbox.Root>
      <Typography
        as="label"
        variant="paragraph020"
        className={twMerge('text-[--checkbox-text-default]', labelClassName)}
        htmlFor={id}
      >
        {children}
      </Typography>
    </div>
  );
};
